import { discardSigninPendingAuth } from "@/lib/signinPendingAuth";

/**
 * ล้าง JWT / user ก่อนสลับ provider (เช่น เคย login Google แล้วกดยืนยัน LINE ใหม่)
 * — ไม่ล้าง localStorage ทั้งก้อน (เก็บ PKCE / oauth path ที่ตั้งหลัง clear)
 */
export async function clearSigninJwtBeforeProviderReconnect(
  nextProvider: "line" | "google",
): Promise<void> {
  if (typeof window === "undefined") return;

  await discardSigninPendingAuth();

  try {
    if (nextProvider === "line") {
      localStorage.removeItem("google_profile");
    } else {
      localStorage.removeItem("line_profile");
      localStorage.removeItem("line_user_id");
    }
  } catch {
    // ignore
  }
}

/**
 * Full client logout cleanup: localStorage, sign-in flow session flags, and httpOnly `auth_token` cookie.
 * Without clearing the cookie + `/signin` sessionStorage, LIFF can look "stuck" or block returning to `/signin`.
 */
export async function clearClientAuthSession(): Promise<void> {
  if (typeof window === "undefined") return;

  try {
    const toRemove: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const k = sessionStorage.key(i);
      if (!k) continue;
      if (
        k.startsWith("signin_") ||
        k.startsWith("liff_path_redirected:") ||
        k.startsWith("signin_oauth_hydrated:")
      ) {
        toRemove.push(k);
      }
    }
    toRemove.forEach((k) => sessionStorage.removeItem(k));
  } catch {
    // ignore
  }

  try {
    localStorage.clear();
  } catch {
    // ignore
  }

  try {
    await fetch("/api/auth/set-token", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ clear: true }),
      credentials: "same-origin",
    });
  } catch {
    // ignore — still proceed with local logout
  }
}
